import React from 'react';

const backdrop = props => <div className="backdrop">{props.children}</div>

export default backdrop;